// Generated by GitHub Copilot
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { CloudOff, Wifi } from 'lucide-react'
import { useNetworkState } from '#core/state/ui/NetworkState.ts'
import { cn } from '#core/utils/cn.ts'

/**
 * App-wide connectivity banner. Mount once at the app root (next to the toast
 * host). While the browser reports no connection it shows a persistent offline
 * warning; when the connection returns it flashes a brief "back online"
 * confirmation and then hides itself. Silent whenever connectivity is fine.
 */
export function OfflineBanner() {
  const { t } = useTranslation('general')
  const net = useNetworkState()

  // Auto-dismiss the transient "back online" confirmation after a few seconds.
  useEffect(() => {
    if (!net.justReconnected) return
    const id = window.setTimeout(() => net.acknowledgeReconnect(), 3000)
    return () => window.clearTimeout(id)
  }, [net.justReconnected, net])

  if (net.online && !net.justReconnected) return null

  const offline = !net.online

  return (
    <div
      className="ynt-top-banner-fixed"
      style={{ zIndex: 1080, paddingTop: 'var(--ynt-app-inset-top)' }}
    >
      <div
        className={cn('alert', offline ? 'alert-warning' : 'alert-success', 'd-flex align-items-center justify-content-center gap-2 mb-0 rounded-0 w-100 py-2 fw-medium text-center shadow-sm')}
        role="status"
        aria-live="polite"
      >
        {offline ? <CloudOff size={16} aria-hidden /> : <Wifi size={16} aria-hidden />}
        <span>{offline ? t('network.offline') : t('network.backOnline')}</span>
      </div>
    </div>
  )
}

export default OfflineBanner
